import Box from '@mui/material/Box';
import '../../styles/login.css';

/**
 * Shown for the moment it takes to validate a stored token on boot. Without it the
 * login screen flashes at someone who is already signed in.
 */
export default function SessionSplash() {
  return (
    <div className="tr-login-wrap">
      <div className="tr-grid" />
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5,
          color: '#fff',
        }}
      >
        <Box className="tr-company-logo" sx={{ m: 0 }}>
          <img src={`${process.env.PUBLIC_URL}/brand-logo.png`} alt="TrustLab Diagnostics" />
        </Box>
        <Box className="tr-pulse-dots">
          <span /><span /><span /><span />
        </Box>
        <Box sx={{ fontSize: 12, letterSpacing: '.14em', textTransform: 'uppercase', opacity: 0.7 }}>
          Restoring your session
        </Box>
      </Box>
    </div>
  );
}
